import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44.291 44.292"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m36.759 14.679-9.412 11.206-9.409 11.211.152-15.631L7.933 9.589l14.413 2.545zm-.37.134L18.09 21.465",
  style: {"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2px","isolation":"isolate"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }